// We have used 'https://icomoon.io/app/#/select' url from where we convert the svg file into font. if you want to add more svg icons then select the previous selection.json file from previous download and then add new icons and download again

const appIcons = {
  analytics: "\ue900",
  users: "\ue901",
  branding: "\ue902",
  content: "\ue903",
  features: "\ue904",
  gamification: "\ue905",
  general: "\ue906",
  outreach: "\ue907",
  polls: "\ue908",
  proposal: "\ue909",
  tickets: "\ue90a",
  website: "\ue90b",
  courses: "\ue933",
  support: "\ue91d",

  // features
  about: "\ue90c",
  attendee: "\ue930",
  community: "\ue90d",
  maps: "\ue90f",
  message: "\ue910",
  exhibitor: "\ue934",
  sponsor: "\ue935",
  news: "\ue911",
  schedule: "\ue912",
  social: "\ue913",
  speaker: "\ue914",
  gallery: "\ue928",
  survey: "\ue929",
  webview: "\ue92a",
  content_gamification: "\ue924",
  advertisement: "\ue94a",

  // Main Settings
  emailtemplate: "\ue925",
  eventsetting: "\ue926",
  passwordsetting: "\ue94d",
  appstore: "\ue951",
  emaillog: "\ue94e",
  usagehistory: "\ue94e",
  api: "\ue952",
  reportissue: "\ue94b",
  billing: "\ue94c",
  language: "\ue953",

  // Branding
  appbranding: "\ue950",
  webbranding: "\ue919",
  appmenu: "\ue918",
  splash: "\ue917",

  // Polls
  liveqa: "\ue90e",
  poll: "\ue915",
  rating: "\ue916",

  // Analytics
  session: "\ue912",
  attendeesnetwork: "\ue90d",
  attendeesmessaging: "\ue910",
  socialfeed: "\ue913",
  sponsorsinsight: "\ue935",
  exhibitorsinsight: "\ue934",
  person: "\ue91f",
  device: "\ue91e",
  link: "\ue936",
  timer: "\ue937",
  attendees: "\ue901",
  attenadoprate: "\ue91c",
  attedengarate: "\ue91b",
  atninteraction: "\ue938",
  messagess: "\ue91d",
  sesslist: "\ue942",
  sessview: "\ue93d",
  sessfavo: "\ue941",
  noofspkr: "\ue945",
  spkrlistview: "\ue942",
  spkrprofview: "\ue901",
  spkrsearch: "\ue943",
  spkrfavo: "\ue941",
  msgsent: "\ue91d",
  profview: "\ue93d",
  attesear: "\ue943",
  attefavo: "\ue941",
  scans: "\ue93f",
  sentmsg: "\ue91d",
  communication: "\ue91f",
  receivemsg: "\ue944",
  msgthread: "\ue93b",
  socialpost: "\ue93e",
  socialreaction: "\ue947",
  socialcomments: "\ue944",
  socialmedia: "\ue940",
  socialpolls: "\ue93a",
  noofspon: "\ue946",
  sponlistview: "\ue942",
  sponprofview: "\ue93d",
  sponsearch: "\ue943",
  sponfavo: "\ue941",
  noofexhi: "\ue93c",
  exhilistview: "\ue942",
  exhiprofview: "\ue93d",
  exhisearch: "\ue943",
  exhifavo: "\ue941",
  advertisementinsight: "\ue94a",

  // Gamifications
  challenge: "\ue920",
  leaderboard: "\ue921",
  reward: "\ue922",

  // User Registration
  wizard: "\ue931",
  appuser: "\ue930",
  formbuilder: "\ue911",
  badgedesign: "\ue94f",
  manageticket: "\ue92b",
  coupon: "\ue91a",
  salesreport: "\ue92f",
  payout: "\ue92c",
  setting: "\ue922",
  proposalwizard: "\ue931",
  proposaldashboard: "\ue92a",
  proposalresponse: "\ue92d",
  proposalreveiwer: "\ue930",

  // Courses
  course: "\ue932",
  quiz: "\ue915",

  // Common
  dashboard: "\ue92a",
  currentfill: "\ue91b",
  firefill: "\ue91c",
  chatfill: "\ue91d",
  messagefill: "\ue944",
  mobilefill: "\ue91e",
  usersfill: "\ue91f",
  settings: "\ue922",
  uploadericon: "\ue923",
  downloadicon: "\ue939",
  linkfill: "\ue936",
  sessionfill: "\ue937",
  tickcirclefill: "\ue938",
  home: "\ue949",
  scanner: "\ue948",
  dotlist: "\ue942",
  heartfill: "\ue941",
  eyefill: "\ue93d",
  mikefill: "\ue945",
  magnifyingglass: "\ue943",
  fourdividersquarefill: "\ue93f",
  editfill: "\ue93b",
  circlechartfill: "\ue93a",
  floppydiskfill: "\ue93e",
  galleryfill: "\ue940",
  thumbsupfill: "\ue947",
  sponsorfill: "\ue946",
  exhibitornewfill: "\ue93c",
  circle_questionmark: "\ue90e",
  blocked: "\uea0e",
};

export default appIcons;
